<script setup>
import { Navigation, Pagination, Zoom } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { defineProps, ref } from 'vue';
import { getImagePath } from '@/common/utils/Util';
import { modalList, show } from '@/common/utils/ModalState';
import { WELL_DYING_CODE } from '@/common/constants/ConstCode';

const props = defineProps(['data']);
const emits = defineEmits(['close']);

const { files, category } = props.data;
let reason = ref('');

const fnReport = () => {
  show(modalList.REPORT_REASON_MODAL, {
    file: files[0]
  });
  emits('close');
};
</script>

<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="detail-view-modal">
        <!-- Swiper -->
        <div class="swiper mySwiper">
          <Swiper
            :zoom="true"
            :pagination="{ type: 'bullets', el: '.swiper-pagination' }"
            :modules="[Pagination, Navigation, Zoom]"
            :navigation="true"
          >
            <SwiperSlide v-for="(file, index) in files" :key="index">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="slide">
                    <div class="swiper-zoom-container">
                      <!--<img :src="getImagePath(file?.storedFileName)" alt="photo" />-->
                      <!--<img :src="getLocalImagePath(file?.storedFileName)" alt="photo" />-->

                      <video
                        controls
                        playsinline
                        :poster="getImagePath(file?.thumbnail.storedFileName)"
                        v-if="category === WELL_DYING_CODE.WELL_PRAY.key"
                      >
                        <source :src="getImagePath(file?.storedFileName)" type="video/mp4" ref="video" />
                      </video>
                      <video controls playsinline :poster="file?.thumbnail?.storedFileName" v-else>
                        <source :src="file?.storedFileName" type="video/mp4" ref="video" />
                      </video>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <!-- MEMO: 좌우 방향키(prev, next)는 css에서 이미 적용되어 있기 때문에 따로 html 추가 필요없음 -->
            <div class="swiper-button-close" @click.stop="$emit('close')"></div>
          </Swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
